var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.134,
    height: 25.231,
    viewBox: "0 0 25.134 25.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#6f7d83;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-946.524 -581.548)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(946.524 581.548)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 14.695,
    transform: "translate(0 4.221)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8.504,
    transform: "translate(17.168)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 7.971,
    transform: "translate(17.161 4.221)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 16.095,
    y2: 0.027,
    transform: "translate(955.562 594.093)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.501,
    transform: "translate(959.138 602.527)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8.504,
    transform: "translate(953.263 589.872)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.744,
    transform: "translate(946.524 594.093)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8.504,
    transform: "translate(956.784 598.275)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.267,
    transform: "translate(946.524 602.496)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.11df762aa1ff93036590c2b552b3f6ac.svg";
export { ForwardRef as ReactComponent };